interface JotMeetNavigationAvailability {
  isAvailable: boolean;
  isLoading: boolean;
}

/**
 * Keep catalog-backed navigation hidden until availability is confirmed.
 *
 * The explicit loading guard prevents a future hook refactor from briefly
 * exposing the Telehealth item before the bundle catalog resolves.
 */
export function shouldShowJotMeetNavigation({
  isAvailable,
  isLoading,
}: JotMeetNavigationAvailability): boolean {
  return !isLoading && isAvailable;
}
